import React, { FC, useState } from "react";
import { Button, Modal, Row, Col, Card, Avatar, Descriptions, Space, notification, Tag } from "antd";
import avatar from "../../images/avatar.png";
import "./UserLink.scss";
import { UserInfoCard } from "./UserInfoCard";
import { FamilyAddChild } from "./FamilyAddChild";
import { FamilyAddParent } from "./FamilyAddParent";
import { StopTwoTone } from "@ant-design/icons";
import { observer } from "mobx-react";
import { familyStore } from "../../store/family/FamilyStore";
import { Store } from "../../store/Store";
import NumberFormat from "react-number-format";
import { FamilyEditNote } from "./FamilyEditNote";
import moment from "moment";
import { fmtDate } from "../../common/Utils";
import { Api } from "../../common/Api";
import { ApolloError } from "apollo-client";
import { SexOffenderIcon } from "../SexOffenderIcon";
import { FamilyEnableAccountBtn } from "./FamilyEnableAccountBtn";
import { FamilyDisableAccountBtn } from "./FamilyDisableAccountBtn";
import { FamilyUserRoles } from "./FamilyUserRoles";

interface UserLinkProps {
  name: string;
  fullName?: string;
  userId?: string;
  childId?: string;
}

export const UserLink: FC<UserLinkProps> = observer(({ name, fullName, userId, childId }) => {
  const [showDlg, setShowDlg] = useState(false);
  const onShow = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setShowDlg(true);
    familyStore.show(userId, childId);
  };

  const onChange = () => {
    familyStore.loadData();
  };

  const { curUser } = familyStore;

  const noteUpdate = () => {
    if (curUser?.profile?.noteUpdated) {
      return `(update on ${moment(curUser?.profile?.noteUpdated).format("D/M/YY")})`;
    }
    return "";
  };

  const soUpdate = (state) => {
    let content = "";
    if (state === "Fail") {
      content = `Are you sure to set the user as Sex Offender?`;
    } else {
      content = `Are you sure to set the user as not Sex Offender?`;
    }
    Modal.confirm({
      content,
      onOk: () => {
        return Api.family
          .updateUserSexOffender(curUser?.user.id, state)
          .then((res) => {
            notification.success({
              message: `Success!`,
            });
            curUser.user.sexOffender = res.data.updateUserSexOffender.sexOffender;
            curUser.user.accountDisabled = res.data.updateUserSexOffender.accountDisabled;
          })
          .catch((err: ApolloError) => {});
      },
    });
  };

  const state2 = () => {
    if (curUser?.profile?.dlStatus === "Verified") {
      if (moment(curUser?.profile?.dlExpirationDate).isBefore(moment())) {
        return `Drivers License Expired (${fmtDate(curUser?.profile?.dlExpirationDate)})`;
      } else {
        return "Valid Driver's License";
      }
    } else {
      return "No Drivers License";
    }
  };

  const onDisableAccount = async (reason) => {
    await Api.family.disableUserAccount(curUser?.user.id, reason);
    familyStore.loadData();
  };
  const onEnableAccount = async (reason) => {
    await Api.family.enableUserAccount(curUser?.user.id, reason);
    familyStore.loadData();
  };

  const onUpdateUserRoles = async (roles: string[]) => {
    await Api.family.updateUserRoles(curUser?.user.id, roles);
    familyStore.loadData();
  };

  return (
    <>
      <Button type="link" onClick={(e) => onShow(e)} style={{ padding: 0, height: 22 }}>
        {name}
      </Button>
      <Modal
        title={`${fullName || name}'s Family`}
        visible={showDlg}
        onOk={() => setShowDlg(false)}
        onCancel={() => setShowDlg(false)}
        width={900}
        footer={null}
        className="user-link-dlg"
        bodyStyle={{ paddingTop: 10 }}
      >
        <Card loading={familyStore.loading}>
          {!Store.isDivision && (
            <div style={{ marginBottom: 10 }}>
              <Space>
                <FamilyAddChild family={familyStore.family} onChange={onChange} />
                <FamilyAddParent />
              </Space>
            </div>
          )}
          <Row gutter={12}>
            <Col span={12}>
              {familyStore.family.parents.map((p) => (
                <UserInfoCard
                  key={p.user.id}
                  user={p}
                  isActive={p.user.id === familyStore.curUser?.user?.id}
                  onUser={(u) => (familyStore.curUser = u)}
                  onChange={onChange}
                />
              ))}
            </Col>
            <Col span={12}>
              {familyStore.curUser && (
                <Card className="user-detail-card" size="small">
                  <Card.Meta
                    avatar={
                      <Avatar
                        src={
                          familyStore.curUser?.user?.avatar
                            ? `https://${process.env.REACT_APP_CLOUDFRONT}.cloudfront.net/${curUser?.user?.avatar}`
                            : avatar
                        }
                      />
                    }
                    title={
                      <div style={{ display: "flex", alignItems: "center", position: "relative" }}>
                        {curUser?.user?.name}{" "}
                        <div style={{ marginLeft: 10 }}>
                          {curUser?.user?.role?.includes("Child") && <Avatar size="small" src="/minor.png" />}
                        </div>
                        <div style={{ flexGrow: 1 }}></div>
                        <div>
                          {curUser?.user?.accountDisabled === true ? (
                            <FamilyEnableAccountBtn
                              enableAccount={onEnableAccount}
                              sexOffender={curUser?.user?.sexOffender.state === "Fail"}
                            />
                          ) : (
                            <FamilyDisableAccountBtn disableAccount={onDisableAccount} />
                          )}
                        </div>
                      </div>
                    }
                    description={
                      <div>
                        <Descriptions column={1} size="small">
                          <Descriptions.Item>
                            <NumberFormat value={curUser?.user?.mobile} format="+# (###) ###-####" displayType="text" />
                          </Descriptions.Item>
                          <Descriptions.Item>{curUser?.user?.email}</Descriptions.Item>
                          {/* <Descriptions.Item>
                            <strong style={{ marginRight: 20 }}>
                              Status{" "}
                              {curUser?.user?.state === "Verified" && (
                                <CopyrightOutlined style={{ fontSize: "16px", color: "#08c" }} />
                              )}
                            </strong>
                            {curUser?.user?.state === "Verified" && curUser?.profile?.dlStatus !== "Verified"
                              ? "ParentShare Ready (cannot drive carpool) "
                              : ""}
                            {curUser?.user?.state === "Verified" && curUser?.profile?.dlStatus === "Verified"
                              ? "ParentShare Ready (can drive carpool) "
                              : ""}
                          </Descriptions.Item> */}
                        </Descriptions>

                        <Descriptions
                          title={
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                              <span>Roles</span>
                              <FamilyUserRoles
                                role={curUser?.user?.role || []}
                                updateUserRoles={onUpdateUserRoles}
                              ></FamilyUserRoles>
                            </div>
                          }
                          column={1}
                          size="small"
                          style={{ marginTop: 10 }}
                        >
                          <Descriptions.Item style={{ display: "block" }}>
                            {(curUser?.user?.role || []).map((r) => (
                              <Tag color="processing" key={r}>
                                {r == "Child" ? "Minor" : r}
                              </Tag>
                            ))}
                          </Descriptions.Item>
                        </Descriptions>

                        <Descriptions column={1} size="small" style={{ marginTop: 10 }}>
                          <Descriptions.Item> {curUser?.profile?.intro}</Descriptions.Item>
                        </Descriptions>

                        <Descriptions title="Interest " column={1} size="small">
                          <Descriptions.Item> {curUser?.profile?.interests} </Descriptions.Item>
                        </Descriptions>

                        <Descriptions title="ID Verification" column={1} size="small">
                          <Descriptions.Item>
                            {curUser?.profile?.idStatus || "Unverified"}
                            <br />
                            {curUser?.profile?.idStatus === "Verified" && state2()}
                          </Descriptions.Item>
                        </Descriptions>

                        <Descriptions title="Sex Offender Database Check" column={1} size="small">
                          <Descriptions.Item>
                            <div>
                              {curUser?.user?.sexOffender && (
                                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                  <SexOffenderIcon type={curUser?.user?.sexOffender.state} />
                                  Last updated at {fmtDate(curUser.user.sexOffender.lastUpdated)}
                                </div>
                              )}
                              <Space size="small">
                                {curUser?.user?.sexOffender?.state !== "Fail" && (
                                  <Button size="small" onClick={() => soUpdate("Fail")}>
                                    Set is Sex Offender
                                  </Button>
                                )}
                                {curUser?.user?.sexOffender?.state !== "Pass" && (
                                  <Button size="small" onClick={() => soUpdate("Pass")}>
                                    Set is not Sex Offender
                                  </Button>
                                )}
                              </Space>
                            </div>
                          </Descriptions.Item>
                        </Descriptions>

                        <Descriptions title="User Stats" column={1} size="small">
                          <Descriptions.Item label="App Rating">
                            {curUser?.user?.appRate || 0} ({curUser?.user?.appRateCount || 0})
                          </Descriptions.Item>
                          {/* <Descriptions.Item label="Feedback">10</Descriptions.Item> */}
                          <Descriptions.Item label="User Rating">
                            {curUser?.user?.userRate || 0} ({curUser?.user?.userRateCount || 0})
                          </Descriptions.Item>
                          {/* <Descriptions.Item label="Community Post"> - </Descriptions.Item>
                          <Descriptions.Item label="ParentShare Post"> - </Descriptions.Item>
                          <Descriptions.Item label="ParentShare Completed"> - </Descriptions.Item>
                          <Descriptions.Item label="Fundraising"> - </Descriptions.Item> */}
                          <Descriptions.Item label="Last Login">
                            {fmtDate(curUser?.lastActivity, "-")}
                          </Descriptions.Item>
                          {/* <Descriptions.Item label="Joined"> - </Descriptions.Item> */}
                        </Descriptions>

                        <Descriptions
                          title={
                            <span>
                              Note
                              <span style={{ fontSize: "12px", color: "rgba(0,0,0,.65)" }}> {noteUpdate()}</span>
                              <FamilyEditNote></FamilyEditNote>
                            </span>
                          }
                          column={1}
                          size="small"
                        >
                          <Descriptions.Item>{curUser?.profile?.note}</Descriptions.Item>
                        </Descriptions>
                      </div>
                    }
                  />
                  {curUser?.user?.accountDisabled === true && (
                    <StopTwoTone
                      twoToneColor="#eb2f96"
                      style={{ position: "absolute", top: -30, left: 160, fontSize: 80, opacity: 0.5 }}
                    />
                  )}
                </Card>
              )}
            </Col>
          </Row>
        </Card>
      </Modal>
    </>
  );
});
